export default "__VITE_ASSET__CSHqBsi9__"